import { render, staticRenderFns } from "./DgOogCertiPop.vue?vue&type=template&id=73edb972"
import script from "./DgOogCertiPop.vue?vue&type=script&lang=js"
export * from "./DgOogCertiPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73edb972')) {
      api.createRecord('73edb972', component.options)
    } else {
      api.reload('73edb972', component.options)
    }
    module.hot.accept("./DgOogCertiPop.vue?vue&type=template&id=73edb972", function () {
      api.rerender('73edb972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DgOogCertiPop.vue"
export default component.exports